import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Commune {
  name: string;
  api_token: string;
}

export interface CommuneDetaiInfor {
  errors: unknown;
  Commune: Commune;
  isAuthenticated: boolean;
}

@Module
export default class CommuneDetail
  extends VuexModule
  implements CommuneDetaiInfor
{
  errors = {};
  Commune = {} as Commune;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get CommuneDetail() {
    return this.communeDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.COMMUNE_DETAIL_DATA](Commune) {
    this.communeDetailData = Commune;
  }
  @Action
  [Actions.COMMUNE_DETAIL](payload) {
    return ApiService.getDataDetail("/gis/commune", payload, "detail", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.COMMUNE_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
